import { sanitizeCategory } from "app/utils";
import { MENTION_VALUE, SEGMENTED_VALUE } from "constants/mentionConstants";

interface Props {
  tags: any[] | undefined;
}

const typeExists = (
  newBody: any,
  name: string,
  type: string
) => Object.values(newBody.entityMap).find(
  (entity: any) => entity.data.name === name
  && entity.data.type === type
);

const useAddTags = ({ tags }: Props) => (body: string) => {
  const newBody = JSON.parse(body);
  const keys = Object.keys(newBody.entityMap);
  // Get the last key of the object to add the new values with the next key
  let lastKey = keys.length > 0 ? parseInt(keys[keys.length - 1], 10) + 1 : 0;

  if (!tags) return JSON.stringify(newBody);

  tags.forEach(option => {
    const name = option.label || option;
    const type = sanitizeCategory(option);
    const exists = typeExists(newBody, name, type);

    if (!exists) {
      newBody.entityMap[lastKey] = {
        type: MENTION_VALUE,
        mutability: SEGMENTED_VALUE,
        data: {
          type,
          entityId: option.value,
          name
        }
      };
      lastKey += 1;
    }
  });

  return JSON.stringify(newBody);
};

export default useAddTags;
